"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Paragraph = require("../../atoms/Paragraph");

var _Spacer = require("../../layout/Spacer");

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _ButtonService = require("./ButtonService.styles");

var _excluded = ["name", "text", "dataTestId", "active", "action"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonService = function ButtonService(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'nurse' : _ref$name,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Seguimiento COVID' : _ref$text,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-button-service' : _ref$dataTestId,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      action = _ref.action,
      props = _objectWithoutProperties(_ref, _excluded);

  var arr_text = text.split('|n');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_ButtonService.Occ_ButtonService, {
    "data-test-id": dataTestId,
    onClick: action
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    name: name,
    service: true,
    color: active ? 'secondary' : 'primary'
  }), props["new"] && /*#__PURE__*/_react["default"].createElement(_ButtonService.Occ__Div, null, /*#__PURE__*/_react["default"].createElement(_Paragraph.Paragraph, {
    size: "base",
    color: "white"
  }, "Nuevo")), /*#__PURE__*/_react["default"].createElement(_Spacer.Spacer, {
    direction: "vertical",
    value: "5px"
  }), /*#__PURE__*/_react["default"].createElement(_Paragraph.Paragraph, {
    color: "primary",
    size: "xxxs",
    weight: "normal",
    align: "center",
    forceMultiline: true
  }, arr_text.map(function (line, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, line);
  }))));
};

var _default = ButtonService;
exports["default"] = _default;